import { useMemo } from 'react';
import sortBy from 'lodash/sortBy';

import { ViewProps } from 'approot/activity-builder/components/response/response.constants';
import { useResponseBaseHeight } from 'approot/activity-builder/components/response/response.hooks';
import { useSimpleModalState } from 'approot/shared/modal/modal.hooks';
import SubActivityView from 'approot/activity-builder/components/sub-activity/sub-activity-view';
import { ZoomComponentTrigger } from 'approot/activity-builder/activity-builder-zoom-component-modal';
import {
  ResponseBox,
  ResponseContainer,
  ResponseField,
} from '../response-print.style';
import ActivitySheet from '../../shared/sheet/activity-sheet';
import {
  ZoomComponentContent,
  ZoomComponentContentInner,
} from 'approot/activity-builder/activity-builder-zoom-component-modal.style';

const ResponseStudentStatic = ({
  id,
  type,
  properties,
  subActivityProperties,
}: ViewProps) => {
  const { isVisible, openModal, closeModal } = useSimpleModalState();
  const baseHeight = useResponseBaseHeight();
  const sortedFields = useMemo(
    () => sortBy(properties.textResponse.fields, 'sort'),
    [properties.textResponse.fields]
  );
  return (
    <>
      {isVisible && (
        <ActivitySheet
          isVisible
          hasBackgroundColor
          title="Text response"
          onClose={closeModal}
        >
          <ZoomComponentContent>
            <ZoomComponentContentInner>
              <SubActivityView
                withTTSButton
                componentId={id}
                componentType={type}
                subActivityDetails={subActivityProperties}
              >
                <ResponseContainer>
                  {sortedFields.map(field => (
                    <ResponseBox
                      key={field.itemId}
                      $baseColour={field.baseColour}
                    >
                      {[...Array(field.numberOfLines)].map((_, i) => (
                        <ResponseField
                          key={i}
                          $baseHeight={baseHeight}
                          data-selector="response-line-print"
                        >
                          {i === 0 && field.isPlaceholderScaffold && (
                            <span>{field.placeholder}</span>
                          )}
                        </ResponseField>
                      ))}
                    </ResponseBox>
                  ))}
                </ResponseContainer>
              </SubActivityView>
            </ZoomComponentContentInner>
          </ZoomComponentContent>
        </ActivitySheet>
      )}

      <SubActivityView subActivityDetails={subActivityProperties}>
        {openModal && (
          <ZoomComponentTrigger
            ariaLabel="Expand to view text response"
            openModal={openModal}
          />
        )}
        <ResponseContainer>
          {sortedFields.map(field => (
            <ResponseBox key={field.itemId} $baseColour={field.baseColour}>
              {[...Array(field.numberOfLines)].map((_, i) => (
                <ResponseField
                  key={i}
                  $baseHeight={baseHeight}
                  data-selector="response-line-print"
                >
                  {i === 0 && field.isPlaceholderScaffold && (
                    <span>{field.placeholder}</span>
                  )}
                </ResponseField>
              ))}
            </ResponseBox>
          ))}
        </ResponseContainer>
      </SubActivityView>
    </>
  );
};

export default ResponseStudentStatic;
